import {
  useMutation,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type {
  ResponseDto,
  RequestReactivationCodeResponseDto,
} from "@mimber/schema"

export const useRequestReactivationCode = (
  options?: UseMutationOptions<
    ResponseDto<RequestReactivationCodeResponseDto>,
    Error,
    void
  >
): UseMutationResult<
  ResponseDto<RequestReactivationCodeResponseDto>,
  Error,
  void
> => {
  guardAppUsage("mimber-organization", "useRequestReactivationCode")

  const { server } = useServerContext()

  return useMutation({
    ...options,
    mutationFn: async () => {
      const response = await server.post<
        ResponseDto<RequestReactivationCodeResponseDto>
      >("account/request-reactivation-code")
      return response.data
    },
  })
}
